/* eslint-disable react/jsx-key */
import React, { lazy } from "react";
import LandingPage from "pages/LandingPage";
import WithTracker from "components/Tracker";

const Home = lazy(() => import("../pages/Home"));
const BookActivity = lazy(() => import("../pages/BookActivity"));
const Invitation = lazy(() => import("../pages/Invitation"));
// const Share = lazy(() => import("../pages/Share"));

const routes = (basename = "") => [
  {
    path: basename + "/",
    exact: true,
    element: <LandingPage />,
  },
  {
    path: basename + "/home",
    exact: true,
    element: (
      <WithTracker ga="view_activty">
        <Home />
      </WithTracker>
    ),
  },
  // {
  //   path: basename + "/share",
  //   exact: true,
  //   element: (
  //     <WithTracker ga="view_share">
  //       <Share />
  //     </WithTracker>
  //   ),
  // },
  {
    path: basename + "/invitation",
    exact: true,
    element: <Invitation />,
  },
  {
    path: basename + "/book",
    element: (
      <WithTracker ga="view_book">
        <BookActivity />
      </WithTracker>
    ),
  },
];

export default routes;
